import ls from 'localstorage-slim';

const CS_ADMIN_STORE_SECRET_KEY = 'CS_ADMIN_STORE_SECRET_KEY';
const CS_ADMIN_CURRENT_STORE_TITLE = 'CS_ADMIN_CURRENT_STORE_TITLE';

export const setCurrentStoreTitle = (storeTitle: string) => {
  localStorage.setItem(CS_ADMIN_CURRENT_STORE_TITLE, storeTitle);
};

export const setCurrentStoreSecretKey = (secretKey: string) => {
  ls.set(CS_ADMIN_STORE_SECRET_KEY, secretKey);
};

export const getCurrentStoreTitle = () => {
  return localStorage.getItem(CS_ADMIN_CURRENT_STORE_TITLE) ?? '';
};

export const getCurrentStoreSecretKey = () => {
  return ls.get(CS_ADMIN_STORE_SECRET_KEY);
};
